import FunnelSankeyChart from '@/components/charts/FunnelSankeyChart.tsx';
import { funnelToSteps } from '@/components/charts/funnelAdapter.ts';
import {
  InfoCard,
  InfoCardBody,
  InfoCardHeader,
} from '@/components/ui/InfoCard.tsx';
import HeadlineNumber from '@/components/ui/HeadlineNumber.tsx';
import MetricList from '@/components/ui/MetricList.tsx';
import NoItems from '@/components/ui/NoItems.tsx';
import { EMPTY_VALUE } from '@/components/ui/EmptyValue.tsx';
import { FunnelDto } from '@/types/stats/FunnelDto.ts';
import { formatMetricValue } from '@/types/stats/metric.utils.ts';
import { FUNNEL_STAGE_REGISTRY } from '@/features/dashboard/tours/types/sales/funnelStages.utils.ts';
import { funnelMetricLabel } from '@/features/dashboard/tours/types/sales/funnelMetrics.utils.ts';
import { formatShare } from '@/features/dashboard/tours/types/share.utils.ts';

interface SignupFunnelCardProps {
  funnel: FunnelDto;
}

/** Droga od wejścia na ofertę do pierwszej wpłaty, z odpływami i odbiciami. */
const SignupFunnelCard = ({ funnel }: SignupFunnelCardProps) => {
  const steps = funnelToSteps(funnel.stages, FUNNEL_STAGE_REGISTRY);
  const conversion = formatShare(
    steps[steps.length - 1]?.count ?? 0,
    steps[0]?.count ?? 0,
  );

  const metricRows = funnel.metrics.map((metric) => ({
    id: metric.key,
    label: funnelMetricLabel(metric.key),
    value: formatMetricValue(metric),
  }));

  return (
    <InfoCard>
      <InfoCardHeader title="Lejek zapisu">
        <div className="mt-2 flex items-baseline gap-2">
          <HeadlineNumber>{conversion ?? EMPTY_VALUE}</HeadlineNumber>
          <span className="text-[13px] text-neutral-500">
            z wejść na ofertę do pierwszej wpłaty
          </span>
        </div>
      </InfoCardHeader>
      <InfoCardBody>
        {steps.length > 0 ? (
          <>
            <FunnelSankeyChart steps={steps} ariaLabel="Lejek zapisu" />

            {metricRows.length > 0 && <MetricList rows={metricRows} />}

            <p className="text-[13px] text-neutral-400">
              Pierwsze trzy progi liczą sesje przeglądarki, dalsze — rezerwacje.
            </p>
          </>
        ) : (
          <NoItems
            title="Brak danych o lejku"
            description="Nikt jeszcze nie wszedł na ofertę tego wyjazdu."
          />
        )}
      </InfoCardBody>
    </InfoCard>
  );
};

export default SignupFunnelCard;
